import { wrapFunctionalComponent } from 'utils/framework';
import { Flex, Image } from 'components/ui';
import { radii, space, colors } from 'style/config';
import localeUtils from 'utils/LanguageLocale';
import VideoIconOverlayEN from './locales/VideoIconOverlay_en_US';
import VideoIconOverlayFR from './locales/VideoIconOverlay_fr_CA';

const styles = {
    button: {
        position: 'absolute',
        bottom: space[4],
        left: space[4],
        zIndex: 1,
        cursor: 'pointer',
        width: space[7],
        height: space[7],
        border: 'none',
        padding: 0,
        borderRadius: radii.full,
        overflow: 'hidden',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundColor: colors.darken4
    }
};

const getText = localeUtils.getLocalisedDataFromResource(VideoIconOverlayEN, VideoIconOverlayFR);

const VideoIconOverlay = ({ onClick, thumbnailSrc }) => (
    <button
        css={styles.button}
        style={thumbnailSrc ? { backgroundImage: `url(${thumbnailSrc})` } : undefined}
        onClick={onClick}
        aria-label={getText('playVideo')}
    >
        <Flex
            width='100%'
            height='100%'
            alignItems='center'
            justifyContent='center'
            backgroundColor={colors.darken4}
        >
            <Image
                src='/img/ufe/icons/play-sm.svg'
                disableLazyLoad={true}
                width={11}
                height={12}
            />
        </Flex>
    </button>
);

export default wrapFunctionalComponent(VideoIconOverlay, 'VideoIconOverlay');
